// ----
// JS for compact add to cart buttons
// ----

/**
* @typedef {Object} Resource
* @property {number} id
* @property {number} typeId
*/

var SCM = SCM || {};

SCM.CompactAddToCartButton = (function ($) {
    var dataService;

    return {
        init: init
    };

    function init() {
        if (!$('.js-addToCartButton').length && !$('.js-bulk-cart-add').length) {
            return;
        }

        dataService = SCM.CompactAddToCartButton.DataService;
        bindUiEvents();
        hideResourcesNotAvailableForPurchase();
        disableResourceIdsAlreadyInCart();
    }

    function bindUiEvents() {
        var $delegateElement = $('#main');
        $delegateElement.on('click', '.js-addToCartButton',
            function () {
                var $this = $(this);
                addResourceToCart($this.data('resourceId'), $this.data('resourceTypeId'));
            });

        $delegateElement.on('click', '#js-add-to-cart-success-modal .js-close-modal',
            function () {
                $('#js-add-to-cart-success-modal').removeClass('open');
            });

        $delegateElement.on('change', '.js-checkBoxClass', handleResourceCheckBoxChange);

        $delegateElement.on('click', '.js-bulk-cart-add', handleBulkAddToCart);

        $delegateElement.on('click', '.js-bulk-cart-add-issue', handleIssueBulkAddToCart);

        $delegateElement.ajaxComplete(handleAjaxComplete);
    }

    function hideResourcesNotAvailableForPurchase() {
        $('.js-addToCartButton').each(function () {
            var $this = $(this);
            if ($this.data('userRestricted') !== 'True' && hasAccess($this.data('resourceId'))) {
                $this.data('userRestricted', 'False');
            } else {
                $this.data('userRestricted', 'True');
            }

            if ($this.data('userRestricted') === 'False') {
                $this.hide();
            }
        });
    }

    function disableResourceIdsAlreadyInCart() {
        dataService.getResourceIdsAlreadyInCart()
            .then(function(resourceIds) {
                $('.js-addToCartButton').each(function() {
                    var $this = $(this);

                    if (resourceIds.includes($this.data('resourceId'))) {
                        $this.data('inUserCart', 'true');
                        $this.addClass('disabled');
                    }
                });
            })
            .catch(function (reason) {
                console.error('Failed to get resourceIds in cart.', reason);
            });
    }

    function updateCartIcon(numberOfItemsInCart) {
        if ($('.items-in-cart').length && numberOfItemsInCart.length && !isNaN(parseInt(numberOfItemsInCart))) {
            $('.items-in-cart').text(numberOfItemsInCart);
        }
    }

    function hasAccess(resourceId) {
        if (!resourceId) {
            return false;
        }

        if (SCM.AccessAttributes) {
            return hasAccessPerAccessAttributes(resourceId);
        }

        return hasAccessPerCheckbox(resourceId);
    }

    function hasAccessPerAccessAttributes(resourceId) {
        return !SCM.AccessAttributes
            .filter(function (x) { return x.id === resourceId; })
            .map(function (x) { return x.availableforpurchase; })
            .shift();
    }

    function hasAccessPerCheckbox(resourceId) {
        var checkboxAvailableForPurchase = $('input.js-checkBoxClass[data-resource-id=' + resourceId + ']')
            .data('availableForPurchase');
        return checkboxAvailableForPurchase !== 'True';
    }

    function addResourceToCart(resourceId, resourceType) {
        dataService.addResourceToCart(resourceId, resourceType)
            .then(function(cartItemCount) {
                updateCartIcon(cartItemCount);
                updateAddToCartButton(resourceId);
                displayModal();
            })
            .catch(function (reason) {
                console.error('Failed to add resource to cart.', reason);
            });
    }

    function updateAddToCartButton(resourceId) {
        $('.js-addToCartButton[data-resource-id=' + resourceId + ']').attr('data-in-user-cart', 'true');
        $('.js-addToCartButton[data-resource-id=' + resourceId + ']').addClass('disabled');
    }

    function displayModal() {
        $('#js-add-to-cart-success-modal').addClass('open');
    }

    function handleResourceCheckBoxChange(e) {
        var $parentSection = $(e.currentTarget)
            .closest('section');
        var anyResourcesSelectedResult = anyResourcesSelected($parentSection);
        $parentSection.find('.js-bulk-cart-add, .js-bulk-citation-manager-add')
            .prop('disabled', !anyResourcesSelectedResult)
            .attr('aria-disabled', !anyResourcesSelectedResult);

        var $issueSection = $('.section-container');
        anyResourcesSelectedResult = anyResourcesSelected($issueSection);
        $('.js-bulk-cart-add-issue, .js-bulk-citation-manager-add-issue')
            .prop('disabled', !anyResourcesSelectedResult)
            .attr('aria-disabled', !anyResourcesSelectedResult);
    }

    function anyResourcesSelected($section) {
        return selectedResourcesInSection($section).length;
    }

    /**
     * 
     * @param {JQuery} $section
     * @returns {Resource[]}
     */
    function selectedResourcesInSection($section) {
        return $section.find('.js-checkBoxClass:checked')
            .map(function(i, resourceCheckBox) {
                return { id: $(resourceCheckBox).data('resourceId'), typeId: $(resourceCheckBox).data('resourceTypeId') };
            })
            .get();
    }

    function handleBulkAddToCart(e) {
        var $parentSection = $(e.currentTarget)
            .closest('section');
        var selectedResources = selectedResourcesInSection($parentSection);
        filterAndAddResourcesToCart(selectedResources);
    }

    function filterAndAddResourcesToCart(selectedResources) {
        if (!Array.isArray(selectedResources) || !selectedResources.length) {
            return;
        }
        dataService.getResourceIdsAlreadyInCart()
            .then(function(resourceIdsInCart) {
                var resourcesToAddToCart = selectedResources
                    .filter(function(resource) {
                        return !hasAccess(resource.id) && !resourceIdsInCart.includes(resource.id);
                    });
                if (!resourcesToAddToCart.length) {
                    alert('No selected resources are available for purchase.');
                    return;
                }
                addResourcesToCart(resourcesToAddToCart);
            })
            .catch(function (reason) {
                console.error('Failed to get resourceIds in cart.', reason);
            });
    }

    function handleIssueBulkAddToCart() {
        var selectedResources = selectedResourcesInSection($('.section-container'));
        filterAndAddResourcesToCart(selectedResources);
        
        return;
       
    }

    function addResourcesToCart(resources) {
        SCM.CompactAddToCartButton.DataService.addResourcesToCart(resources)
            .then(function(cartItemCount) {
                updateCartIcon(cartItemCount);
                resources.forEach(function(resource) {
                    updateAddToCartButton(resource.id);
                });
                displayModal();
            })      
            .catch(function(reason) {
                console.error('Failed to add all resources to cart.', reason);
            });
       
    }

    function handleAjaxComplete(e, jqXhr, settings) {
        if (settings.url && settings.url.toLowerCase().includes('searchresults')) {
            hideResourcesNotAvailableForPurchase();
            disableResourceIdsAlreadyInCart();
        }
    }

})(jQuery);

SCM.CompactAddToCartButton.DataService = (function ($) {
    return {
        addResourceToCart: addResourceToCart,
        addResourcesToCart: addResourcesToCart,
        getResourceIdsAlreadyInCart: getResourceIdsAlreadyInCart
    };

    function addResourceToCart(resourceId, resourceTypeId) {
        return $.ajax({
                type: 'POST',
                url: '/Store/AddProductToCartAjax/addtocartbutton',
                data: {
                    resourceId: resourceId,
                    resourceTypeId: resourceTypeId
                },
                cache: false
            })
            .promise()
            .then(function(response) {
                if (!response.Success) {
                    return Promise.reject('Action returned non-success status');
                }

                if (!Array.isArray(response.Messages) || response.Messages.length < 1 || !response.Messages[0].length) {
                    return Promise.reject('Action did not return expected response');
                }

                return response.Messages[0];
            });
    }

    /**
     * 
     * @param {Resource[]} resources
     */
    function addResourcesToCart(resources) {
        var ajaxData = { resources: resources.map(function(r) { return { Id: r.id, Type: r.typeId }; }) };
        return $.ajax({
                type: 'POST',
                url: '/Store/AddProductsToCartAjax/addtocartbutton',
                data: ajaxData,
                cache: false
            })
            .promise()
            .then(function (response) {
                if (!response.Success) {
                    return Promise.reject('Action returned non-success status');
                }

                if (!Array.isArray(response.Messages) || response.Messages.length < 1 || !response.Messages[0].length) {
                    return Promise.reject('Action did not return expected response');
                }

                return response.Messages[0];
            });
    }

    /**
     * @param {number[]} numberArray
     * @returns {number}
     */
    function maxValue(numberArray) {
        return numberArray.sort(function(a, b) { return b - a; })
            .shift();
    }

    function getResourceIdsAlreadyInCart() {
        return $.ajax({
                type: 'POST',
                url: '/Store/GetArticleResourcesInCartAjax/addtocartbutton',
                cache: false
            })
            .promise()
            .then(function(response) {
                if (!response.Success) {
                    return Promise.reject('Action return non-success status');
                }

                if (!Array.isArray(response.Messages) || !response.Messages.length) {
                    return Promise.reject('Action did not return expected response');
                }

                return parseListOfIntegers(response.Messages[0]);
            });

        /**
         * Given a string containing a comma-separated list of integer values, return an array of integers
         * @param {string} intListString
         * @returns {number[]}
         */
        function parseListOfIntegers(intListString) {
            return intListString.split(',')
                .map(function (s) {
                    return parseInt(s);
                })
                .filter(function (i) {
                    return !isNaN(i);
                });

        }
    }

})(jQuery);
